const initialState = () => ({
  plan: {},
  paidUsers: [],
  clientUsers: [],
  companies: [],
});

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    plan(state, x) {
      state.plan = x;
    },
    paidUsers(state, x) {
      state.paidUsers = x;
    },
    clientUsers(state, x) {
      state.clientUsers = x;
    },
    companies(state, x) {
      state.companies = x;
    },
  },
};
